import type React from 'react';
import printConfig from './printConfig.json';

const { page, palette, typography } = printConfig;

const pageMargin = `${page.margin_mm.top}mm ${page.margin_mm.right}mm ${page.margin_mm.bottom}mm ${page.margin_mm.left}mm`;

// Shared CSS injected into print views to align preview with backend settings.
export const sharedPrintStyles = `
  @page {
    size: ${page.size} ${page.orientation};
    margin: ${pageMargin};
  }

  @media print {
    body {
      background: ${palette.background};
      margin: 0;
      font-family: ${typography.baseFamily}, sans-serif;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }

    .print-page {
      padding: 0;
      margin: 0;
    }

    .no-print { display: none !important; }
    table { page-break-inside: auto; }
    thead { display: table-header-group; }
    tr { page-break-inside: avoid; page-break-after: auto; }
  }
`;

export const basePrintContainerStyle: React.CSSProperties = {
  fontFamily: `${typography.baseFamily}, sans-serif`,
  color: palette.text,
  backgroundColor: palette.background,
};

